
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"300","height":"104","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 88.971l12.783-24.685 18.8-23.315m0 4.8L59.388 54M25.551 66.343L48.11 74.57m23.31-19.2L63.9 81.43v15.085l39.103-2.743M71.42 78.686l23.311-2.057M75.932 61.543L97.74 60.17l18.799-4.8m1.504 16.458L127.817 102m-18.799-28.8l12.032-3.429 18.799-3.428 5.263 9.6-21.516 13.028m4.221-3.428l33.086 6.857M148.12 60.171l18.799-9.6 21.055-5.485 3.008 11.657-18.799 9.6m4.512 2.057l30.078 7.543M151.88 45.086l18.799 26.743 6.016 13.028m26.318-56.228l6.016 24 11.279 19.2 7.52-1.372 16.543-17.143m0 0l-9.776-34.285m9.776 34.285l4.512 18.515m17.295-3.429l-9.024-39.771 5.264-20.572h5.263l5.264 10.972 3.008 15.085 6.016-19.885L286.48 6h3.008L294 14.229v21.257l-6.016 38.4","stroke":"#000","stroke-width":"12"}})])
          )
        }
      }
    